import { useMutation } from '@apollo/client';
import {
  CREATE_NEW_ROLE,
  CreateNewRoleData,
  CreateNewRoleInput,
} from '../../../../apollo/queries/v3/RolesNPermissions/createNewRole.queries';
import { RNPToastHelper } from '../../RNPToaster';
import { CONFLICT } from '../../../../utils/constants';

const useCreateNewRoleAPI = () => {
  const [createRole] = useMutation<CreateNewRoleData>(CREATE_NEW_ROLE, {});

  const createNewRole = async (
    input: CreateNewRoleInput,
    onComplete: () => void,
  ) => {
    try {
      const { data } = await createRole({
        variables: { input },
      });

      if (data && data.createCustomRole) {
        onComplete();
        RNPToastHelper.createNewRoleSuccess({ roleName: input.name });
      }
    } catch (e: any) {
      if (
        e.graphQLErrors &&
        e.graphQLErrors.length > 0 &&
        e.graphQLErrors[0].validationErrors?.status === CONFLICT
      ) {
        RNPToastHelper.conflictError();
      } else {
        RNPToastHelper.error();
      }
    }
  };

  return [createNewRole];
};

export default useCreateNewRoleAPI;
